// Depo içi en kısa yol: raflar engel, 8 yönlü A* (ızgara), çoklu durakta en yakın komşu sırası.
export const rafBoyut = (r) => {
  const uz = (r.sutun * r.goz_en_cm) / 100, der = r.goz_derinlik_cm / 100;
  return r.rot === 90 ? { w: der, d: uz } : { w: uz, d: der };
};

export const gozMerkez = (r, s, g) => {
  const ge = r.goz_en_cm / 100, gh = r.goz_yukseklik_cm / 100, der = r.goz_derinlik_cm / 100;
  const y = 0.1 + (g - 1) * gh + gh / 2;
  return r.rot === 90 ? { x: r.x + der / 2, y, z: r.z + (s - 0.5) * ge } : { x: r.x + (s - 0.5) * ge, y, z: r.z + der / 2 };
};

const izgara = (plan) => {
  const h = Math.max(0.5, Math.max(plan.en_m, plan.boy_m) / 160);
  const W = Math.ceil(plan.en_m / h), D = Math.ceil(plan.boy_m / h);
  const blok = new Uint8Array(W * D);
  plan.raflar.forEach((r) => {
    const { w, d } = rafBoyut(r);
    for (let i = Math.floor(r.x / h); i < Math.ceil((r.x + w) / h); i++) for (let j = Math.floor(r.z / h); j < Math.ceil((r.z + d) / h); j++) if (i >= 0 && j >= 0 && i < W && j < D) blok[j * W + i] = 1;
  });
  return { h, W, D, blok };
};

const yakinBos = (g, x, z) => {
  const i0 = Math.min(g.W - 1, Math.max(0, Math.round(x / g.h))), j0 = Math.min(g.D - 1, Math.max(0, Math.round(z / g.h)));
  for (let r = 0; r < Math.max(g.W, g.D); r++) for (let di = -r; di <= r; di++) for (let dj = -r; dj <= r; dj++) {
    const i = i0 + di, j = j0 + dj;
    if (i >= 0 && j >= 0 && i < g.W && j < g.D && !g.blok[j * g.W + i]) return [i, j];
  }
  return [i0, j0];
};

const astar = (g, a, b) => {
  const N = g.W * g.D, key = (i, j) => j * g.W + i, hz = (i, j) => { const dx = Math.abs(i - b[0]), dz = Math.abs(j - b[1]); return dx + dz - 0.586 * Math.min(dx, dz); };
  const gs = new Float32Array(N).fill(Infinity), from = new Int32Array(N).fill(-1), kapali = new Uint8Array(N);
  const acik = [[hz(...a), key(...a)]];
  gs[key(...a)] = 0;
  while (acik.length) {
    let m = 0; for (let n = 1; n < acik.length; n++) if (acik[n][0] < acik[m][0]) m = n;
    const [, k] = acik.splice(m, 1)[0];
    if (kapali[k]) continue;
    kapali[k] = 1;
    const i = k % g.W, j = (k / g.W) | 0;
    if (i === b[0] && j === b[1]) break;
    for (let di = -1; di <= 1; di++) for (let dj = -1; dj <= 1; dj++) {
      if (!di && !dj) continue;
      const ni = i + di, nj = j + dj;
      if (ni < 0 || nj < 0 || ni >= g.W || nj >= g.D || g.blok[key(ni, nj)]) continue;
      if (di && dj && (g.blok[key(i + di, j)] || g.blok[key(i, j + dj)])) continue;
      const nk = key(ni, nj), c = gs[k] + (di && dj ? 1.414 : 1);
      if (c < gs[nk]) { gs[nk] = c; from[nk] = k; acik.push([c + hz(ni, nj), nk]); }
    }
  }
  const bk = key(...b);
  if (from[bk] === -1 && bk !== key(...a)) return null;
  const yol = [];
  for (let k = bk; k !== -1; k = from[k]) yol.push([(k % g.W) * g.h, ((k / g.W) | 0) * g.h]);
  return { yol: yol.reverse(), mesafe: gs[bk] * g.h };
};

// Rafın önündeki koridor noktası (göze erişilen yer)
export const erisim = (r, s) => {
  const m = gozMerkez(r, s, 1), { w, d } = rafBoyut(r);
  return r.rot === 90 ? [[r.x - 0.6, m.z], [r.x + w + 0.6, m.z]] : [[m.x, r.z - 0.6], [m.x, r.z + d + 0.6]];
};

export const enKisaRota = (plan, duraklar) => {
  if (!plan?.raflar?.length) return null;
  const g = izgara(plan);
  const nokta = (p) => yakinBos(g, p[0], p[1]);
  let cur = nokta([plan.giris.x, plan.giris.z]);
  const kalan = duraklar.map((d) => d.adaylar.map(nokta));
  const sira = [], parcalar = [];
  let toplam = 0;
  while (kalan.length) {
    let best = null;
    kalan.forEach((ad, n) => ad.forEach((p) => { const r = astar(g, cur, p); if (r && (!best || r.mesafe < best.r.mesafe)) best = { n, p, r }; }));
    if (!best) return null;
    parcalar.push(best.r.yol); toplam += best.r.mesafe; sira.push(duraklar[best.n].ad);
    cur = best.p; kalan.splice(best.n, 1); duraklar = duraklar.filter((_, i) => i !== best.n);
  }
  const son = astar(g, cur, nokta([plan.cikis.x, plan.cikis.z]));
  if (!son) return null;
  parcalar.push(son.yol); toplam += son.mesafe;
  return { noktalar: parcalar.flat(), mesafe: Math.round(toplam * 10) / 10, sira };
};
